import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as messagingActions from "../../../../_actions/messagingActions";
import Messages from "./Messages";
import getChatInfo from "../../../../_selectors/messagingSelectors/getChatInfo";
import getSelectedChatId from "../../../../_selectors/messagingSelectors/getSelectedChatId";
import getSelectedChatCachedUser from "../../../../_selectors/messagingSelectors/getSelectedChatCachedUser";
import getSelectedChatUser from "../../../../_selectors/messagingSelectors/getSelectedChatUser";
import getSelectedMessagingId from "../../../../_selectors/messagingSelectors/getSelectedMessagingId";
class Chat extends Component {
  //TO-DO UPDATE THE CONVERSATION IF THE NAME OR IMAGE URL IS CHANGED
  state = { msg: "" };
  componentDidMount() {
    const {
      selectedId,
      getUserInformation,
      messagingId,
      getMessages
    } = this.props;
    const unsubscribeUserInformation = getUserInformation(selectedId);
    const unsubscribeMessages = getMessages(messagingId);
    this.unsubscribe = () => {
      unsubscribeMessages();
      unsubscribeUserInformation();
    };
  }
  componentDidUpdate(prevProps) {
    const {
      user,
      cachedUser,
      updateImage,
      messagingId,
      selectedId
    } = this.props;
    if (user && cachedUser) {
      if (user.imageURL !== cachedUser.imageURL) {
        updateImage({ messagingId, image: user.imageURL, selectedId });
      }
    }
  }
  componentWillUnmount() {
    const { clearChat } = this.props;
    this.unsubscribe();
  }
  sendMessage = event => {
    event.preventDefault();
    const { send, messagingId, selectedId } = this.props;
    const { msg } = this.state;
    const message = {
      receiver: selectedId,
      message: msg
    };
    const onSuccess = () => {
      this.setState({ msg: "" });
    };
    send({ messagingId, message, onSuccess });
  };
  render() {
    const {
      onChatClose,
      info,
      cachedUser,
      clearChat,
      user,
      selectedId,
      messagingId
    } = this.props;
    const { msg } = this.state;
    if (!info.messagingId) {
      return null;
    }
    return (
      <div class="rightbar-chat-frame-chat">
        <div class="user">
          <div class="user-panel">
            <a
              onClick={clearChat}
              class="btn btn-default btn-rounded rightbar-chat-close"
            >
              <span class="fa fa-angle-left" />
            </a>
            <Link
              to={`/view-profile/${info.id}`}
              class="btn btn-default btn-rounded pull-right"
              title="View Profile"
            >
              <span class="fa fa-user" />
            </Link>
          </div>
          <div class="user-info">
            <div
              className={
                user
                  ? user.status === "online"
                    ? "user-info-image status online"
                    : "user-info-image status away"
                  : "user-info-image status away"
              }
            >
              <img src={user ? user.imageURL : cachedUser.imageURL} />
            </div>
            <h5>{user ? user.name : cachedUser.name}</h5>
          </div>
        </div>
        <Messages messagingId={messagingId} receiver={selectedId} />

        <form className="form" onSubmit={this.sendMessage}>
          <div className="form-group">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={msg}
                onChange={event => {
                  this.setState({ msg: event.target.value });
                }}
                name="message"
              />
              <div className="input-group-btn">
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={msg === "" ? true : false}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  info: getChatInfo(state),
  selectedId: getSelectedChatId(state),
  messagingId: getSelectedMessagingId(state),
  cachedUser: getSelectedChatCachedUser(state),
  user: getSelectedChatUser(state)
});

const mapDispatchToProps = dispatch => ({
  clearChat: () => dispatch(messagingActions.clearChat()),
  getUserInformation: profileId =>
    dispatch(messagingActions.getChatUserInformation(profileId)),
  getMessages: messagingId =>
    dispatch(messagingActions.loadUpChatMessages(messagingId)),
  send: payload => dispatch(messagingActions.sendMessage(payload)),
  updateImage: payload =>
    dispatch(messagingActions.updateParticipantImageUrl(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat);



// WEBPACK FOOTER //
// ./src/_components/Layout/RightSidebar/Chat/index.js